var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon21({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9937 26.5052V3.14746H34.1938V26.5052H3.79989V3.14746H0V30.3948H37.999V26.5052H37.9937Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6072 34.2002H11.4023V38.0001H26.6083L26.6072 34.2002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9015 30.4014H17.1016V34.2013H20.9015V30.4014Z",
    fill: "#FFBB07"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4011 22.7921L6.26172 17.638L8.95542 14.958L11.4053 17.4195L19.0114 9.81973L22.8113 13.6196L29.0611 7.36035L31.7485 10.0467L22.805 18.9933L18.9988 15.1934L11.4011 22.7921Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79989 0H0V3.79989H3.79989V0Z",
    fill: "#FFBB07"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0887 14.7383L11.4023 17.4246L14.0887 20.1109L16.776 17.4246L14.0887 14.7383Z",
    fill: "#FFBB07"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0004 0H22.8008V3.79989H38.0004V0Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1792 0H3.80078V3.79989H22.8066V0H18.1792Z",
    fill: "#2650FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6106 17.638L11.6169 17.6316L8.92956 14.9453L6.24219 17.6316L8.71107 20.1058L11.3984 22.7921L14.0858 20.1058L11.6106 17.638Z",
    fill: "#2650FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon21);
export default __webpack_public_path__ + "static/media/feature_icon_2_1.95add3c1864bd00816909665b9c8190d.svg";
export { ForwardRef as ReactComponent };